import { AuthorizedUser } from "../models/AuthorizedUser";
import { http } from "../http/Http";

export class DownloadService {
    downloadDocument = async (documentSecurityId: string): Promise<string | null> => {
        let logitudeTokens = localStorage.getItem("LogitudeTokens") || "";
        let downloadDocumentUrl = "Download/DownloadDocument?securityId=" + documentSecurityId + "&authorizationToken=" + AuthorizedUser.getToken() + "&logitudetokens=" + logitudeTokens;
        return http.getFullUrl(downloadDocumentUrl);
    };

    downloadAllDocument = async (shipmentId: string): Promise<string | null> => {
        let logitudeTokens = localStorage.getItem("LogitudeTokens") || "";
        let downloadDocumentUrl = "Download/DownloadAllDocument?shipmentId=" + shipmentId + "&authorizationToken=" + AuthorizedUser.getToken() + "&logitudetokens=" + logitudeTokens;
        return http.getFullUrl(downloadDocumentUrl);
    };

    downloadInvoice = async (invoiceId: string): Promise<string | null> => {
        let logitudeTokens = localStorage.getItem("LogitudeTokens") || "";
        let downloadInvoiceUrl = "Download/DownloadInvoice?invoiceId=" + invoiceId + "&authorizationToken=" + AuthorizedUser.getToken() + "&logitudetokens=" + logitudeTokens;
        return http.getFullUrl(downloadInvoiceUrl);
    };
}